import React from 'react'
import { DepositHeader } from '../index'
import UploadFile from '../Components/UploadFile'
import MoneyInput from '../Components/MoneyInput'
import UserBankSelect from '../Components/UserBankSelect'
import OldBankSixNumber from '../Components/OldBankSixNumber'
import SubmitBtn from '../Components/SubmitBtn'
import DatePicker from '../Components/DatePicker'
import Modal from '../Components/Modal';
import SuccessPage from '../Components/SuccessPage'
import OldBankCon from '$Deposits/Components/LB/OldBank'


class OldBank extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {

    }
    componentWillUnmount() {

    }


    render() {


        return (

            <>

                <OldBankCon
                    OldBank={(propCon) => {
                        const {
                            MethodsActive,
                            onChange,
                            submitBtn,
                            LivechatClick,
                            backClick,
                        } = propCon

                        return (
                            <div className='oldBankModal'>
                                <div className='oldBankHeader'>
                                    <span className='backClick' onClick={backClick} />
                                    <h3>
                                        บัญชีธนาคารเก่า
                                    </h3>
                                </div>
                                <div className='oldBankModalCenter'>
                                    <div className='viewArea'>
                                        <MoneyInput/>
                                        <UserBankSelect/>
                                        <div className='tipsGray' data-CN="若要新增銀行帳號請聯絡客服">
                                            หากต้องการเพิ่มบัญชีใหม่ กรุณาติดต่อฝ่ายบริการลูกค้า <span onClick={LivechatClick}>ห้องช่วยเหลือสด</span>
                                        </div>
                                        <OldBankSixNumber/>
                                        <div className='DatePickerolumn'>
                                            <div>
                                                {/* 日期选择 */}
                                                <p className='inputTitle' data-CN="存款日期">วันที่ฝาก</p>
                                                <DatePicker
                                                    mode={'date'}
                                                    titleText={'วันที่ฝาก'}
                                                />
                                            </div>
                                            <div>
                                                {/* 时间选择 */}
                                                <div className='inputTitle'>
                                                    <p data-CN="存款時間">เวลาที่ฝาก</p>
                                                    <span className="required-label">จำเป็นต้องกรอก</span>
                                                </div>
                                                <DatePicker
                                                    mode={'time'}
                                                    titleText={'เวลาฝาก'}
                                                />
                                            </div>
                                        </div>
                                        {/* 上传图片 */}
                                        <UploadFile />
                                    </div>

                                    <SubmitBtn
                                        submitBtn={submitBtn}
                                        onPress={onChange}
                                        submitBtnItem={'โอนเงินมาเรียบร้อย'}  //提交
                                    />
                                </div>

                            </div>
                        )
                    }}
                    SuccessPage={SuccessPage}
                />

            </>

        );
    }
}

export default OldBank



